import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-checkbox',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss'],
})
export class SwitchComponent implements OnInit {

  @Input() shape = '';
  @Input() type:string = '';
  @Input() size:string = '';

  constructor() { }

  ngOnInit(): void {
  }

}
